import https from "./https-common";

const signIn = (user) => {
  return https.post("/login", user);
};

const logout = () => {
  return https.post("/logout");
};

const refresh = () => {
  return https.post("/refresh");
};

const getUserInfo = () => {
  return https.get("/userInfo");
};

const createAccount = (user) => {
  return https.post("/createAccount", user);
};

const AuthService = {
  signIn,
  logout,
  refresh,
  getUserInfo,
  createAccount,
};

export default AuthService;
